const presentationStorageKey = "brainics.presentationMode";
const companyIdStorageKey = "brainics.currentCompanyId";
const specialistIdStorageKey = "brainics.currentSpecialistId";

const demoCompanyId = "91d08ce7-a3ea-4cdd-b3e0-2099b4a0ef1c";
const demoSpecialistId = "6e313914-cbac-4328-b894-8b4f3d5cfc90";

const demoSkillNames: Record<string, string> = {
  "dd6c6c09-9b83-44de-98c0-18ce41eeaf44": "TypeScript",
  "6adc875a-3f12-4608-93dd-a9eaf300af5d": "Node.js",
  "212001c2-f174-40ad-a7fb-f4c6b9d267b8": "PostgreSQL",
  "80000000-0000-4000-8000-000000000101": "Docker",
  "80000000-0000-4000-8000-000000000102": "Redis",
  "80000000-0000-4000-8000-000000000103": "React",
};

const technicalLabels: Array<[RegExp, string]> = [
  [/\bvendor_owned\b/g, "Профиль компании-подрядчика"],
  [/\bindependent\b/g, "Независимый профиль"],
  [/\bvendor_owner\b/g, "Владелец компании"],
  [/\bvendor_manager\b/g, "Менеджер компании"],
  [/\bclient_owner\b/g, "Владелец компании"],
  [/\bclient_manager\b/g, "Менеджер компании"],
  [/\binvited_member\b/g, "Участник компании"],
  [/\bpending_review\b/g, "На модерации"],
  [/\bverified\b/g, "Подтверждён"],
  [/\bunverified\b/g, "Не подтверждён"],
  [/\brejected\b/g, "Отклонён"],
  [/\barchived\b/g, "В архиве"],
  [/\bactive\b/g, "Активный"],
  [/\binactive\b/g, "Неактивный"],
  [/\bhourly_or_monthly\b/g, "Почасовая или месячная ставка"],
  [/\bhourly\b/g, "Почасовая ставка"],
  [/\bmonthly\b/g, "Месячная ставка"],
  [/\bnegotiable\b/g, "По договорённости"],
  [/\bremote\b/g, "Удалённо"],
  [/\bhybrid\b/g, "Гибридный формат"],
  [/\bonsite\b/g, "В офисе"],
  [/\bflexible\b/g, "Гибкий формат"],
  [/\bfull_time\b/g, "Полная занятость"],
  [/\bpart_time\b/g, "Частичная занятость"],
  [/\bproject_based\b/g, "Проектная работа"],
  [/\bcontract\b/g, "Контракт"],
  [/\bfreelance\b/g, "Фриланс"],
  [/\bavailable_from\b/g, "Доступен с указанной даты"],
  [/\bavailable\b/g, "Доступен"],
  [/\bunavailable\b/g, "Недоступен"],
  [/\bnot_looking\b/g, "Не рассматривает предложения"],
  [/\bvendor_reported\b/g, "Добавлен компанией"],
  [/\bself_reported\b/g, "Указан специалистом"],
  [/\bBackend готов\b/g, "Реализовано"],
  [/\bBrainics staff\b/g, "Команда Brainics"],
  [/\bWorkspace\b/g, "Рабочий кабинет"],
  [/\bLevel\b/g, "Уровень"],
  [/\bsoon\b/g, "план"],
  [/\bdocument\b/g, "Документ"],
  [/\blogo\b/g, "Логотип"],
];

function presentationEnabledFromUrl(): boolean | null {
  const parameters = new URLSearchParams(window.location.search);
  const value = parameters.get("presentation");

  if (value === "1") return true;
  if (value === "0") return false;

  return null;
}

function formatDate(value: string): string {
  const date = new Date(`${value}T00:00:00`);

  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat("ru-RU", {
    year: "numeric",
    month: "short",
  }).format(date);
}

function formatBytes(value: number): string {
  if (value >= 1024 * 1024) {
    return `${(value / (1024 * 1024)).toFixed(1)} МБ`;
  }

  if (value >= 1024) {
    return `${Math.round(value / 1024)} КБ`;
  }

  return `${value} байт`;
}

function replaceTechnicalText(value: string): string {
  let result = value;

  result = result.replace(
    /Skill ([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi,
    (_match, skillId: string) => demoSkillNames[skillId.toLowerCase()] ?? "Профессиональный навык",
  );

  result = result.replace(
    /\s*·\s*[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
    "",
  );

  result = result.replace(/\bapplication\/pdf\b/g, "PDF");
  result = result.replace(/\bimage\/svg\+xml\b/g, "SVG");
  result = result.replace(/\btext\/plain\b/g, "TXT");

  result = result.replace(/\b(\d+)\s+bytes\b/gi, (_match, bytes: string) =>
    formatBytes(Number(bytes)),
  );

  result = result.replace(/\b\d{4}-\d{2}-\d{2}\b/g, (date) => formatDate(date));

  for (const [pattern, label] of technicalLabels) {
    result = result.replace(pattern, label);
  }

  result = result.replace(
    "Добавление навыков по skillId из справочника.",
    "Профессиональные навыки, уровень владения и подтверждение компетенций.",
  );

  result = result.replace(
    "Создание, загрузка и редактирование основной карточки специалиста.",
    "Структурированный профессиональный профиль специалиста.",
  );

  result = result.replace(
    "Метаданные файлов компании и внутренние заметки для команды Brainics.",
    "Документы компании и служебная информация.",
  );

  result = result.replace(
    "Создание, редактирование и отправка компании на модерацию.",
    "Основные сведения, юридические данные и статус проверки компании.",
  );

  return result;
}

function hideElement(element: HTMLElement): void {
  if (element.dataset.presentationHidden !== "true") {
    element.dataset.presentationHidden = "true";
  }
}

function processSections(): void {
  const hiddenSectionMarkers = ["Текущая компания", "Текущий специалист", "Создать профиль"];

  for (const section of document.querySelectorAll<HTMLElement>("section")) {
    const text = section.textContent ?? "";

    if (hiddenSectionMarkers.some((marker) => text.includes(marker))) {
      hideElement(section);
    }
  }
}

function processParagraphs(): void {
  for (const paragraph of document.querySelectorAll<HTMLElement>("p")) {
    const text = paragraph.textContent ?? "";

    if (
      text.trim().startsWith("ID:") ||
      text.includes("frontend использует текущий companyId") ||
      text.includes("frontend использует specialistId") ||
      text.includes("Endpoint “моя компания”") ||
      text.includes("Independent создаётся для аккаунта специалиста")
    ) {
      hideElement(paragraph);
    }
  }
}

function isCreationForm(form: HTMLFormElement): boolean {
  const text = form.textContent ?? "";
  const heading = form.querySelector("h2")?.textContent?.trim();

  const markers = [
    "Создать компанию",
    "Пригласить менеджера",
    "Добавить metadata файла",
    "Внутренняя заметка",
    "Добавить навык",
    "Добавить опыт",
    "Добавить проект",
  ];

  if (markers.some((marker) => text.includes(marker))) return true;

  return heading === "Образование" || heading === "Сертификат" || heading === "Язык";
}

function processForms(): void {
  for (const form of document.querySelectorAll<HTMLFormElement>("form")) {
    if (isCreationForm(form)) {
      hideElement(form);
      continue;
    }

    if (form.dataset.presentationReadonly !== "true") {
      form.dataset.presentationReadonly = "true";
    }

    const controls = form.querySelectorAll<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >("input, textarea, select");

    for (const control of controls) {
      if (!control.disabled) control.disabled = true;
    }

    for (const button of form.querySelectorAll<HTMLElement>("button")) {
      hideElement(button);
    }
  }
}

function processModerationControls(): void {
  const dangerousButtonLabels = new Set([
    "Verify",
    "Reject",
    "Block",
    "Archive",
    "Деактивировать",
    "Активировать",
  ]);

  for (const button of document.querySelectorAll<HTMLButtonElement>("button")) {
    if (dangerousButtonLabels.has(button.textContent?.trim() ?? "")) {
      hideElement(button);
    }
  }

  for (const input of document.querySelectorAll<HTMLInputElement>("input")) {
    if (input.placeholder.includes("Причина для reject")) {
      hideElement(input);
    }
  }
}

function processTextNodes(): void {
  if (!document.body) return;

  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const nodes: Text[] = [];

  let current = walker.nextNode();

  while (current) {
    if (current instanceof Text) nodes.push(current);
    current = walker.nextNode();
  }

  for (const node of nodes) {
    const parent = node.parentElement;

    if (!parent || parent.closest("[data-presentation-hidden='true']")) continue;

    const currentValue = node.nodeValue ?? "";
    const nextValue = replaceTechnicalText(currentValue);

    if (nextValue !== currentValue) {
      node.nodeValue = nextValue;
    }
  }
}

function ensurePresentationBanner(): void {
  const main = document.querySelector("main");

  if (!main || main.querySelector("[data-presentation-banner='true']")) return;

  const banner = document.createElement("section");
  banner.dataset.presentationBanner = "true";
  banner.className = "presentation-banner";
  banner.innerHTML = `
    <div>
      <strong>Демонстрационный режим</strong>
      <span>Функциональный прототип Brainics с демонстрационными данными</span>
    </div>
    <span class="presentation-banner__date">Июль 2026</span>
  `;

  main.prepend(banner);
}

function processPresentationDom(): void {
  if (document.documentElement.dataset.presentation !== "true") return;
  if (!window.location.pathname.startsWith("/app")) return;

  ensurePresentationBanner();
  processSections();
  processParagraphs();
  processForms();
  processModerationControls();
  processTextNodes();
}

function enablePresentationMode(): void {
  localStorage.setItem(presentationStorageKey, "1");
  localStorage.setItem(companyIdStorageKey, demoCompanyId);
  localStorage.setItem(specialistIdStorageKey, demoSpecialistId);

  document.documentElement.dataset.presentation = "true";
  document.title = "Brainics — демонстрационный кабинет";

  processPresentationDom();

  let scheduled = false;

  const observer = new MutationObserver(() => {
    if (scheduled) return;

    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      processPresentationDom();
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

export function initializePresentationMode(): void {
  const urlValue = presentationEnabledFromUrl();

  if (urlValue === false) {
    localStorage.removeItem(presentationStorageKey);
    delete document.documentElement.dataset.presentation;
    return;
  }

  const stored = localStorage.getItem(presentationStorageKey) === "1";

  if (urlValue === true || stored) {
    enablePresentationMode();
  }
}
